import React from "react";
import { Trans } from "react-i18next";

export default function Literatur() {
  require("./Pages.sass");

  return (
    <div className="contentview-wrapper txt-only">
      <div className="content-top-wrapper">
        <div className="container-md">
          <h1 className="content-top-heading">
            {" "}
            <Trans i18nKey="ui.weitere_info" />
          </h1>
        </div>
      </div>
      <article className="content-sec" id="literatur">
        <div className="container-md">
          <h2>
            {" "}
            <Trans i18nKey="ui.medien_liter" />
          </h2>
          <section className="flex-container">
            <div>
              <img
                src={require("../resources/images/cover_213-026.jpg")}
                alt="Cover DGUV Information 213-026"
              />
            </div>
            <div>
              <span>
                <Trans i18nKey="ui.dguv_info" />
              </span>
              <h2>
                <Trans i18nKey="ui.sicherheit" /> <br />
                <Trans i18nKey="ui.hochschulprakt" />
              </h2>
              <h3>
                <Trans i18nKey="ui.studierende" />{" "}
              </h3>
              <p>
                <strong>
                  <Trans i18nKey="ui.dguv_info" /> 213-026
                </strong>
              </p>
              <p>
                <Trans i18nKey="general.november" />{" "}
              </p>
              <a
                href="https://publikationen.dguv.de/widgets/pdf/download/article/833"
                className="btn"
                target="_/blank"
                rel="noreferrer"
                download
              >
                <Trans i18nKey="ui.pdf" />
              </a>
              <a
                href="https://publikationen.dguv.de/regelwerk/dguv-informationen/833/sicherheit-im-chemischen-hochschulpraktikum"
                className="btn"
                target="_/blank"
                rel="noreferrer"
              >
                DGUV Shop
              </a>
            </div>
          </section>
          <section className="flex-container">
            <div>
              <img
                src={require("../resources/images/cover_213-850.jpg")}
                alt="Cover DGUV Information 213-850"
              />
            </div>
            <div>
              <h2>
                <Trans i18nKey="ui.sicher" />{" "}
              </h2>
              <h3>
                <Trans i18nKey="ui.grundlagen" />{" "}
              </h3>
              <p>
                <strong>
                  <Trans i18nKey="ui.dguv_info" /> 213-850
                </strong>
              </p>
              <p>
                <Trans i18nKey="ui.auflage" />
              </p>
              <a
                href="https://mediencenter.bgrci.de/shop/bgi850-0_01/detail"
                className="btn"
                target="_/blank"
                rel="noreferrer"
                download
              >
                {" "}
                <Trans i18nKey="ui.pdf" />
              </a>
              <a
                href="https://mediencenter.bgrci.de/shop/bgi850-0/detail"
                className="btn"
                target="_/blank"
                rel="noreferrer"
              >
                <Trans i18nKey="ui.medienshop" />{" "}
              </a>
              <a
                href="https://mediencenter.bgrci.de/shop/bgi850-0/detail"
                className="btn"
                target="_/blank"
                rel="noreferrer"
              >
                <Trans i18nKey="ui.downloads" />{" "}
              </a>
            </div>
          </section>
          <section className="flex-container">
            <div>
              <img
                src={require("../resources/images/cover_t034.jpg")}
                alt="Cover DGUV Information 213-855 T034"
              />
            </div>
            <div>
              <span>
                <Trans i18nKey="ui.sichere_tec" />
              </span>
              <h2>
                <Trans i18nKey="ui.gefaer" />{" "}
              </h2>
              <h3>T 034</h3>
              <p>
                <Trans i18nKey="ui.dguv_info" /> 213 - 855(bisher BGI 850 - 1)
              </p>
              <p>
                <Trans i18nKey="ui.stand" />
              </p>
              <a
                href="https://mediencenter.bgrci.de/shop/t034_01/detail"
                className="btn"
                target="_/blank"
                rel="noreferrer"
                download
              >
                <Trans i18nKey="ui.pdf" />
              </a>
              <a
                href="https://mediencenter.bgrci.de/shop/t034/detail"
                className="btn"
                target="_/blank"
                rel="noreferrer"
              >
                <Trans i18nKey="ui.medienshop" />{" "}
              </a>
              <a
                href="https://mediencenter.bgrci.de/shop/t034_01/detail"
                className="btn"
                target="_/blank"
                rel="noreferrer"
              >
                <Trans i18nKey="ui.downloads" />{" "}
              </a>
            </div>
          </section>
          <section style={{ border: "none" }}>
            <p>
              {" "}
              <Trans i18nKey="ui.weiter" />{" "}
              <a href="https://awa.bgrci.de/" target="_/blank" rel="noreferrer">
                awa.bgrci.de
              </a>
            </p>
          </section>
        </div>
      </article>
    </div>
  );
}
